import React, { memo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { change, Field, formValueSelector } from "redux-form";

import { Button, CheckButton } from "components";

import styles from "./tabsChoose.module.scss";

const AdditionalSection = ({
	feeProgramName,
	feeProgramField,
	formName,
	sectionName,
}) => {
	const dispatch = useDispatch();

	const selector = formValueSelector(formName);
	const sectionShownValue = useSelector(state =>
		selector(state, sectionName),
	);
	const isSectionShown =
		sectionShownValue === "true" || sectionShownValue === true;

	const setSectionShown = useCallback(
		value => {
			dispatch(change(formName, sectionName, value));
		},
		[dispatch, sectionName, formName],
	);

	return (
		<div className={styles.additionalSection}>
			<Field component={CheckButton} name={sectionName} hidden />
			{isSectionShown ? (
				<>
					<hr className="line" />
					<div className={styles.btnRemoveWrapper}>
						<Button
							onClick={() => setSectionShown(false)}
							value={`Remove ${feeProgramName}`}
							variant="secondary"
							className="px-0"
							minWidth="auto"
						/>
					</div>
				</>
			) : (
				<>
					<Button
						onClick={() => setSectionShown(true)}
						value={`Add ${feeProgramName}`}
						variant="secondary"
						className="px-0"
						minWidth="auto"
					/>
				</>
			)}
			{isSectionShown && feeProgramField}
		</div>
	);
};

export default memo(AdditionalSection);
